import type {AiChatGeneratedAssetType} from '@AiChat/ai-chat.types';
import type {EntityCardEntityType} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import type {ChatMessage} from '@Components/ai-chat-window/ai-chat-window.types';

export interface GeneratedImageEvent {
  chatId: string;
  messageId: string | null;
  hashedIds: string[];
  width: number | null;
  height: number | null;
  isFirstGeneration: boolean;
}

export interface GeneratedAssetEvent {
  chatId: string;
  type: AiChatGeneratedAssetType;
  assetHashedFilename: string;
  sourceImageHashedId: string;
  durationInSeconds: number | null;
  hasAudio: boolean | null;
}

export interface MessageSentEvent {
  chatId: string;
}

export interface TurnCompleteEvent {
  chatId: string;
  messages: Record<string, ChatMessage>;
}

export interface GenerationFailedEvent {
  chatId: string;
  message: string;
}

export enum UsedAssetKind {
  IMAGE = 'image',
  ENTITY = 'entity',
}

export interface UsedImageAsset {
  kind: UsedAssetKind.IMAGE;
  chatId: string;
  messageId: string | null;
  hashedId: string;
}

export interface UsedEntityAsset {
  kind: UsedAssetKind.ENTITY;
  chatId: string;
  entityType: EntityCardEntityType;
  entity: Record<string, unknown>;
}

export type UseAssetEvent = UsedImageAsset | UsedEntityAsset;

export interface AiChatCallbacks {
  onChatCreated?: (chatId: string) => void;
  onMessageSent?: (event: MessageSentEvent) => void;
  onImageGenerated?: (event: GeneratedImageEvent) => void;
  onAssetGenerated?: (event: GeneratedAssetEvent) => void;
  onTurnComplete?: (event: TurnCompleteEvent) => void;
  onGenerationFailed?: (event: GenerationFailedEvent) => void;
  onUseAsset?: (event: UseAssetEvent) => void;
}
